import React from 'react';
import { Col, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as DoSelectBadBot } from '../../../assets/svg/images/doselect_bad_bot.svg';
import { IAPIErrorProps } from '../../../types/components/Common/apiError.types';
import { ERROR_MESSAGES } from '../../../constants/APIErrorMessagesConstants';
import Button from '../Buttons/Button';
import styles from './APIError.module.css';
import { DO_CENTRAL_SERVICE_URL } from '../../../constants/AppConstants';

const APIError: React.FC<IAPIErrorProps> = ({ status }) => {
  const navigate = useNavigate();

  const errorMessage = ERROR_MESSAGES[status];

  const handleLink = () => {
    navigate(errorMessage.buttonHref);
  };

  const handleHref = () => {
    window.location.replace(DO_CENTRAL_SERVICE_URL + errorMessage.buttonHref);
  };

  return (
    <div className={styles.apiErrorContainer}>
      <div className={styles.apiErrorCard}>
        <Row className={styles.apiErrorRow}>
          <Col>
            <DoSelectBadBot className={styles.apiErrorImage} />
          </Col>
          <Col className="d-flex flex-column text-center">
            <h1 className={styles.title}>{errorMessage.header}</h1>
            <p className={styles.message}>{errorMessage.message}</p>
            {errorMessage.buttonType === 'link' && (
              <Button
                color="primary"
                className="text-uppercase"
                onClick={handleLink}
              >
                {errorMessage.buttonText}
              </Button>
            )}
            {errorMessage.buttonType === 'href' && (
              <Button
                color="primary"
                className="text-uppercase"
                onClick={handleHref}
              >
                {errorMessage.buttonText}
              </Button>
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default APIError;
